import styled from 'styled-components';

interface ITooltipProps {
  absolutePos?: boolean;
}

export const STooltipWarning = styled.div<ITooltipProps>`
  color: ${({ theme }) => theme.colors.warningBorder};
  position: ${({ absolutePos }) => (absolutePos ? 'absolute' : 'unset')};
  bottom: 1px;
  left: 5px;
  margin-left: ${({ absolutePos }) => (absolutePos ? 'unset' : '10px')};
`;
